<template>
    <record-delete-item
        v-bind:recordData="source"
        v-bind:itemFunc="clickRecordListItem">
    </record-delete-item>
</template>

<script>
/**
 * 记录列表元素类
 */
import RecordDeleteItem from './RecordDeleteItem.vue'
export default {
    name: 'RecordListItem',
    components: { RecordDeleteItem },
    props: {
        source: {
            type: Object,
            default () { return {} }
        }
    },
    methods: {
        clickRecordListItem(recordData) {
            console.log('clickRecordListItem----', recordData);
            if(recordData.zone != 8) {
                this.$bus.emit('showRecordConfirm');
                return;
            }

            var personInfo = this.$store.state.record.recordOriginalData[recordData.id];
            this.$store.dispatch('detail/initDetail', personInfo);
            this.$store.dispatch('detail/updateDetailGlanceTime', personInfo);
            // 更新列表数据
            this.$store.dispatch('record/updateRecordListData', personInfo);
            this.$router.replace('/detail/record/'+ personInfo.id);
        }
    }
}
</script>